__turbopack_context__.v({
  "cta": "T_TxwW_cta",
  "label": "T_TxwW_label",
});
